import platform from '@propertypal/shared/src/utils/platform';
import Head from 'next/head';
import React from 'react';
import EstateAgentInformation from '../components/estate-agent-information/EstateAgentInformation';
import generateMetaTags from '../components/layout/MetaTags';

const metaData = {
  title: `Estate Agents - Join ${platform.title}`,
  // eslint-disable-next-line max-len
  description: `Join Hundreds of Irish and Northern Irish Estate Agents on the Premium Platform For Marketing Property. Get Listed On ${platform.title}.`,
  url: `/estate-agent-information`,
};

const EstateAgentInformationPage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>
      <EstateAgentInformation />
    </>
  );
};

export default EstateAgentInformationPage;
